import "./utility-tools.css";
import { decodeUrlText } from "./utility-tools-core.js";

const root = document.querySelector("[data-url-decoder]");
if (root) {
  const input = document.getElementById("encodedUrl");
  const output = document.getElementById("decodedUrl");
  const status = document.getElementById("urlStatus");
  const plus = document.getElementById("plusAsSpace");
  const decode = () => {
    try {
      output.value = decodeUrlText(input.value, plus.checked);
      status.hidden = true;
    } catch (error) {
      status.textContent = error.message;
      status.hidden = false;
      output.value = "";
    }
  };
  document.getElementById("decodeUrl").addEventListener("click", decode);
  document.getElementById("clearUrl").addEventListener("click", () => { input.value = ""; output.value = ""; status.hidden = true; input.focus(); });
  document.getElementById("copyDecodedUrl").addEventListener("click", async () => {
    if (!output.value) return;
    await navigator.clipboard.writeText(output.value);
    status.textContent = "Decoded result copied.";
    status.hidden = false;
  });
}
